import { Integration } from "@/types/general";

export type ImportableIntegrationSlug = Extract<
    Integration.Components.Slug,
    "poweroffice" | "tripletex" | "twenty_four_seven_office" | "shopify" | "susoft"
>;

export const integrationImportCapabilities: Record<
    ImportableIntegrationSlug,
    Integration.Import.Entity[]
> = {
    poweroffice: ["customer", "supplier", "product"],
    tripletex: ["customer", "supplier", "product", "sale_order"],
    twenty_four_seven_office: ["customer", "supplier", "product", "sale_order", "category"],
    shopify: ["product"],
    susoft: ["product"],
};

export function isImportableIntegrationSlug(
    slug: Integration.Components.Slug
): slug is ImportableIntegrationSlug {
    return slug in integrationImportCapabilities;
}

export function getSupportedImportEntities(
    slug: Integration.Components.Slug
): Integration.Import.Entity[] {
    if (!isImportableIntegrationSlug(slug)) {
        return [];
    }

    return integrationImportCapabilities[slug];
}
